// extracted by mini-css-extract-plugin
export default {"container":"CenteredForm_container__qy7Gx","form":"CenteredForm_form__udypT"};